import { baseApi } from '@/api/rtk/baseApi';

export const profileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMembers: builder.query({
      query: () => ({
        url: '/get-members/',
        method: 'POST',
        body: {},
      }),
      providesTags: ['Members'],
    }),
    getSubstitutes: builder.query({
      query: () => ({
        url: '/get-substitutes/',
        method: 'POST',
        body: {},
      }),
      providesTags: ['Substitutes'],
    }),
    getTransactions: builder.query({
      query: () => ({
        url: '/get-transactions/',
        method: 'POST',
        body: {},
      }),
      providesTags: ['Transactions'],
    }),
  }),
});

export const {
  useGetMembersQuery,
  useGetSubstitutesQuery,
  useGetTransactionsQuery,
} = profileApi;
